<template>
  <transition>
    <div class="notice flexcenter">
      <div class="notice-dialog flexcenter">
        <div v-if="isDocomo(platformName) || isAu(platformName)" class="modal-close" @click="$emit('close')"></div>
        <div class="lbold font16">
          <p>音声が認識できない場合、以下を確認してください。</p>
          <p>1.設定で音声認識が有効になっているか確認してください。無効の場合は有効にしてください。</p>
          <p>2.音声認識が有効にできない場合、最新版にアップデートしてください。</p>
        </div>
        <div class="flexcenter buttons">
          <button v-if="isDocomo(platformName)" class="button" type="button" @click="$emit('close')">
            <a href="dcmstore://launch?url=http%3A%2F%2Fapps.dmkt-sp.jp%2FSpApps%2FdetailApp%3Fdcmstore_view%3Dnone%26cId%3D10000022806" target="_blank" style="color:black;">アップデートページへ</a>
          </button>
          <button v-else-if="isAu(platformName)" class="button" type="button" @click="showUpdatePage()">アップデートページへ</button>
          <button v-else-if="isLibraryAndroid(platformName)" class="button" type="button">
            <a href="http://play.google.com/store/apps/details?id=com.sourcenext.android.rosettastone" target="_blank" style="color:black;">アップデートページへ</a>
          </button>
          <div v-else-if="isPlatformiOS(platformName)">
            <!-- 何も表示しない -->
          </div>
          <button v-else class="button" type="button" @click="$emit('close')">OK</button>
        </div><!-- flexcenter buttons -->
      </div><!-- notice-dialog flexcenter -->
    </div><!-- notice flexcenter -->
  </transition>
</template>

<script>
import common from "@/mixin/common";

export default {
  name: "notice",
  props: {
    platformName: String,
  },
  mixins: [
    common,
  ],
  created: function () {
    this.log("Notice start created");
  },
  mounted: function () {
    this.log("Notice start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function () {
    this.log("Notice start beforeDestroy");
    this.setBodyStylePosition(false);
  },
  methods: {
    /**
     * アップデートページ表示
     */
    showUpdatePage: function () {
      var url = "http://pass.auone.jp/app/detail?app_id=8662210000032";
      window.Phone.StartBrowser(url);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/style/modal";
</style>



// WEBPACK FOOTER //
// Notice.vue?2629ec6e